<template>
    <div class="yhlogin">
        <h2>请输入手机号密码</h2>
        <van-form @submit="onSubmit">
            <van-cell-group inset>
                <van-field
                        v-model="tel"
                        name="账号"
                        label="账号"
                        placeholder="账号"
                        :rules="[{ required: true, message: '请填写账号'}]"
                    />
                <van-field
                    v-model="password"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码'}]"
                />
            </van-cell-group>
            <div style="margin: 30px 16px;">
                <van-button round block type="danger" native-type="submit">
                    提交
                </van-button>
            </div>

            <!-- <van-popup v-model="show" style="padding:0 40px;width:60%">
                <h2 style="margin-top:20px">选择报表</h2>
                <van-radio-group v-model="radio">
                    <van-radio name="1" checked-color="#ee0a24" style="margin-bottom:20px">车辆报表</van-radio>
                    <van-radio name="2" checked-color="#ee0a24">油卡报表</van-radio>
                </van-radio-group>
                <van-button type="danger" @click="go()" style="margin:30px 0;width:100%">确定</van-button>
            </van-popup> -->
        </van-form>
    </div>
</template>

<style scoped lang="less">
    .yhlogin {
        text-align: center;
        h2 {
            margin: 70px 0 40px 0;
        }
        p {
            color: #646566;
            font-weight: 600;
            text-align: right;
            padding-right: 20px;
        }
    }
</style>

<script>
import { login } from '../router/api';

export default {
    data() {
        return {
            tel:'',
            password:'',
        }
    },

    created() {
        var m = Number(localStorage.getItem('data2')?localStorage.getItem('data2'):0);
        var d = Number(localStorage.getItem('data')?localStorage.getItem('data'):0);
        var m2 = new Date().getMonth()
        var d2 = new Date().getDate()
        m2+=1
        m+=1
        if(m2>m) {
            this.$router.push('/bblogin')
        } else {
            if(d2>d) {
                this.$router.push('/bblogin')
            } else {
                this.$router.push('./bbcaidan')
            }
        }
    },

    methods: {
        onSubmit() {
            login({
                tell: this.tel,
                password: this.password,
            }).then(res => {
                if (res.code == 1) {
                    localStorage.setItem("data", new Date().getDate());
                    localStorage.setItem("data2", new Date().getMonth());
                    localStorage.setItem('ws_tell',this.tel);
                    localStorage.setItem('ws_pass',this.password);
                    localStorage.setItem('ws_name',res.data[0].name);
                    this.$router.push('./bbcaidan')
                } else {
                    this.$message.error('登录失败');
                }
            }).catch(err => {
                console.log(err);
            });
        },
        // go() {
        //     console.log(this.radio)
        //     if(this.radio==1) {
        //         this.$router.push('./bbhome');
        //     }
        //     if(this.radio==2) {
        //         this.$router.push('./bbyk');
        //     }
        // },
        
    },
  }
</script>
